let previousEligibleQty = 0;

function checkCartForPWP() {
  if (!window.location.pathname.includes('/cart')) return;

  console.log("🔄 Checking cart for PWP eligibility...");

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const pwpMessages = {
        '44052576272418': { url: '/products/bubble-wrap' },
        '44052587544610': { url: '/products/masking-tape' }
      };

      const pwpVariantIds = Object.keys(pwpMessages);
      let pwpTotal = 0;
      let eligibleQty = 0;

      cart.items.forEach(item => {
        const variantId = item.variant_id.toString();
        const productHandle = item.handle;

        console.log(`📦 ${item.title} | Handle: ${productHandle} | Quantity: ${item.quantity}`);

        if (pwpMessages[variantId] && item.quantity >= 2) {
          const itemNodes = document.querySelectorAll(`[href*="variant=${variantId}"]`);
          itemNodes.forEach(node => {
            const parent = node.closest('.cart-item, tr, td');
            if (parent) {
              const quantityWrapper = parent.querySelector('.quantity-wrapper, .quantity-selector, .quantity');
              if (quantityWrapper && !parent.querySelector('.max-quantity-warning')) {
                const warning = document.createElement('div');
                warning.className = 'max-quantity-warning';
                warning.style.color = 'red';
                warning.style.fontWeight = 'bold';
                warning.style.marginTop = '5px';
                warning.innerHTML = `
                  You've reached the maximum quantity allowed for this item. If you'd like to purchase more, you can do so
                  <a href="${pwpMessages[variantId].url}" style="color: red; text-decoration: underline; margin-left: 5px;">
                    here
                  </a> at the regular price.
                `;
                quantityWrapper.insertAdjacentElement('afterend', warning);
              }

              const plusButton = parent.querySelector('.quantity-up');
              if (plusButton) {
                plusButton.disabled = true;
                plusButton.style.opacity = '0.5';
                plusButton.style.cursor = 'not-allowed';
              }
            }
          });
        }

        if (pwpVariantIds.includes(variantId)) {
          pwpTotal += item.final_line_price / 100;
        }

        if (item.handle === 'all-purpose-packing-box-small-pack-of-5-sample') {
          eligibleQty = item.quantity;
        }
      });

      const cartTotal = cart.total_price / 100;
      const nonPwpTotal = cartTotal - pwpTotal;

      console.log(`💰 Total cart value: RM${cartTotal.toFixed(2)}`);
      console.log(`💰 Non-PWP cart value: RM${nonPwpTotal.toFixed(2)}`);
      console.log(`🔍 Eligible product quantity: ${eligibleQty}`);

      const hasPWP = cart.items.some(item =>
        pwpVariantIds.includes(item.variant_id.toString())
      );

      // ✅ Auto-remove PWP items by clicking remove icon
      if (nonPwpTotal < 50 && hasPWP && !sessionStorage.getItem('pwpRemoved')) {
        console.log("⚠️ Cart is below RM50. Removing PWP items...");

        const removeLinks = document.querySelectorAll('.line_item_remove');
        removeLinks.forEach(link => {
          const href = link.getAttribute('href');
          pwpVariantIds.forEach(variantId => {
            if (href.includes(variantId)) {
              console.log(`🗑️ Removing PWP item with variant ID ${variantId}`);
              link.click(); // ✅ Trigger removal
            }
          });
        });

        alert("⚠️ PWP items are only eligible if your cart total (excluding PWP items) is RM50 and above. They’ve been removed from your cart.");
        sessionStorage.setItem('pwpRemoved', 'true');
      }

      // ✅ Show custom popup only once, with delay
      if (
        eligibleQty > previousEligibleQty &&
        nonPwpTotal >= 50 &&
        !hasPWP &&
        !sessionStorage.getItem('pwpPopupShown')
      ) {
        console.log("🎉 Showing PWP eligibility popup...");

        setTimeout(() => {
          const popup = document.getElementById('addon-popup');
          const overlay = document.getElementById('addon-popup-overlay');
          if (popup && overlay) {
            popup.style.display = 'block';
            overlay.style.display = 'block';
            console.log("✅ Popup triggered successfully.");
          } else {
            console.warn("⚠️ Popup or overlay element not found.");
          }
        }, 1000); // Delay by 1 second

        sessionStorage.setItem('pwpPopupShown', 'true');
      }

      previousEligibleQty = eligibleQty;
    })
    .catch(err => {
      console.error("❌ Error fetching cart:", err);
    });
}

// ✅ Clear sessionStorage on page load for testing
document.addEventListener('DOMContentLoaded', () => {
  console.log("🧹 Resetting sessionStorage flags...");
  sessionStorage.removeItem('pwpPopupShown');
  sessionStorage.removeItem('pwpRemoved');
  checkCartForPWP();
});

// ✅ Re-run when quantity changes
document.addEventListener('change', function (e) {
  if (e.target.matches('.quantity-input, .quantity-selector')) {
    console.log("🔁 Quantity changed. Rechecking cart...");
    setTimeout(checkCartForPWP, 500);
  }
});
